import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Totes_DatasourceService } from './Totes.datasource.index';
import { ProgrammableLogicController_DatasourceService } from './ProgrammableLogicController.datasource.index';


@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.Totes = this.injector.get(Totes_DatasourceService);
    this.ProgrammableLogicController = this.injector.get(ProgrammableLogicController_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public Totes: Totes_DatasourceService;
    public ProgrammableLogicController: ProgrammableLogicController_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
}

